"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isAATestExpired = (controlTestExperimentValue) => {
    // Handle legacy implementation of AA test by allowing it to be cleared from storage
    if (typeof controlTestExperimentValue === 'boolean') {
        return true;
    }
    const sevenDaysInMs = 604800000;
    if (controlTestExperimentValue.createdAt + sevenDaysInMs < Date.now()) {
        return true;
    }
    return false;
};
exports.default = isAATestExpired;
//# sourceMappingURL=isAATestExpired.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/utils/isAATestExpired.js
// module id = sY7d
// module chunks = 69